import { IAutomationObject } from '../../types'

export interface ILocation extends IAutomationObject {
    latitude: number;
    longitude: number;
}

export const schema = 'AutomationApps.Utils.Location';
 